module.exports = __webpack_public_path__ + "static/media/rpa.26c24340.png";